import { v4 as uuidv4 } from 'uuid';

import { IDecision } from 'APIPackage/DecisionModule/interfaces/IDecision';
import { IKnmErknmViolationEvidence } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmViolationEvidence';

export const getDecisionEvidences = (decision: IDecision): IKnmErknmViolationEvidence[] | undefined => {
  const act = decision?.organization?.act;

  if (act && act.videoFixationsCheckbox && act?.videoFixations && act?.videoFixations?.length > 0) {
    const linksList = act.videoFixations?.map(
      item =>
        ({
          guid: item.guid || null,
          date: item.dateVideo,
          description: item.descVideo,
          link: item.linkVideo,
          listId: uuidv4(),
          originPassportId: decision.id, // Поле для хранения id паспорта источника ссылки
          isNew: false,
        } as IKnmErknmViolationEvidence),
    );

    if (Array.isArray(linksList) && linksList.length > 0) {
      return linksList;
    }

    return undefined;
  }
};
